var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container wider"},[_c('header',{staticClass:"header"},[_c('h1',[_vm._v("No published articles at this time.")]),_c('p',[_vm._v("We're working on something exciting. Stay tuned!")])])])
}]

export { render, staticRenderFns }